/*
  This version uses a reactive ref updated by watchEffect rather than a computed.
  The reason is that computed() sometimes fails to update as expected when its
  reactive dependencies come from external sources (e.g. Clerk, async user loads,
  metadata hydration timing). watchEffect re-runs more eagerly and can be more
  reliable in cases where dependency tracking is subtle or inconsistent.
  This is simply what seems most reliable here, but it may not be universally better.
*/
import {ref, watchEffect} from "vue";
import {useLog} from "@/composables/useLog";
import {getIsSubscribed} from "@/composables/subscriptionLists";

const log = useLog("useIsSubscribed"); // any non-empty string is fine
const isSubscribed = ref(false);

export function useIsSubscribed(user, isSignedIn) {
  watchEffect(() => {
    log(
      `isSignedIn=${isSignedIn.value}, ` +
        `hasUser=${!!user.value}, hasMetadata=${!!user.value?.publicMetadata}`
    );
    if (!isSignedIn.value) {
      isSubscribed.value = false;
      return log("→ not signed in, isSubscribed=false");
    }
    const publicMetadata = user.value?.publicMetadata;
    if (!publicMetadata) {
      isSubscribed.value = false;
      return log("→ no publicMetadata, isSubscribed=false");
    }
    isSubscribed.value = getIsSubscribed(publicMetadata); // to any list
    log(`→ subscribed to any list: ${isSubscribed.value}`);
  });
  return isSubscribed;
}
